<template>
	<div class="content">
		<loading v-if="!loaded" />
		<div class="admin" v-if="$store.state.authentication.account_type == 'adm'">
			<div class="md-layout" v-if="loaded">
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>groups</md-icon>
						</template>

						<template slot="content">
							<p class="category">Total clients</p>
							<h3 class="title">{{stat.total_client}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>business</md-icon>
						</template>
						<template slot="content">
							<p class="category">Total loans</p>
							<h3 class="title">{{stat.total_finish_loan}} / {{stat.total_loan}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>business</md-icon>
						</template>
						<template slot="content">
							<p class="category">Total EMIs</p>
							<h3 class="title">{{stat.total_paid_payment}} / {{stat.total_payment}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>supervised_user_circle</md-icon>
						</template>
						<template slot="content">
							<p class="category">Total administrators</p>
							<h3 class="title">{{stat.total_admin}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
					<h3>Overall</h3>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>account_balance</md-icon>
						</template>
						<template slot="content">
							<p class="category">Total capital amount</p>
							<h3 class="title">{{config.moneylify(capital)}}</h3>
						</template>
					</stats-card>
				</div>

				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>account_balance</md-icon>
						</template>
						<template slot="content">
							<p class="category">Total deposits</p>
							<h3 class="title">{{config.moneylify(stat.total_deposit)}}</h3>
						</template>
					</stats-card>
				</div>

				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>account_balance</md-icon>
						</template>
						<template slot="content">
							<p class="category">Total withdraws</p>
							<h3 class="title">{{config.moneylify(stat.total_withdraw)}}</h3>
						</template>
					</stats-card>
				</div>

				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>request_quote</md-icon>
						</template>
						<template slot="content">
							<p class="category">Total loan amount</p>
							<h3 class="title">{{config.moneylify(stat.total_principal)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>price_check</md-icon>
						</template>
						<template slot="content">
							<p class="category">Total interest amount</p>
							<h3 class="title">{{config.moneylify(stat.total_interest)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">Total fee amount</p>
							<h3 class="title">{{config.moneylify(stat.total_fee)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">Total active balance</p>
							<h3 class="title">{{config.moneylify(active_balance)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">Total passive balance</p>
							<h3 class="title">{{config.moneylify(passive_balance)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">Total profit</p>
							<h3 class="title">{{config.moneylify(profit)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
					<h3>Current month income</h3>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">Total amount</p>
							<h3 class="title">
								{{config.moneylify(stat_current_month.total_paid_principal +
								stat_current_month.total_paid_interest + stat_current_month.total_fee)}} / <br>
								<b>{{config.moneylify(stat_current_month.total_principal +
									stat_current_month.total_interest + stat_current_month.total_fee)}}</b>
							</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">Total principal</p>
							<h3 class="title">{{config.moneylify(stat_current_month.total_paid_principal)}} /<br>
								<b>{{config.moneylify(stat_current_month.total_principal)}}</b>
							</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">Total interest</p>
							<h3 class="title">{{config.moneylify(stat_current_month.total_paid_interest)}}
								/<br><b>{{config.moneylify(stat_current_month.total_interest)}}</b></h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">Total fee</p>
							<h3 class="title">{{config.moneylify(stat_current_month.total_fee)}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>paid</md-icon>
						</template>
						<template slot="content">
							<p class="category">Total loan amount</p>
							<h3 class="title">{{config.moneylify(stat_current_month.total_loan_amount)}}</h3>
						</template>
					</stats-card>
				</div>

				<md-card>
					<md-card-header data-background-color="orange">
						<h4>Income by date range</h4>
					</md-card-header>
					<md-card-content>
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-33">
								<md-field>
									<label>Loan Start Date</label>
									<md-input type="text" v-model="range.start_date" style="display:none" />
									<datetime type="date" v-model="range.start_date" auto></datetime>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-33">

								<md-field>
									<label>Loan Start Date</label>
									<md-input type="text" v-model="range.end_date" style="display:none" />
									<datetime type="date" v-model="range.end_date" auto></datetime>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-33">
								<md-button class="md-raised md-primary" style="width:100%" @click="getData()">SHOW</md-button>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>paid</md-icon>
									</template>
									<template slot="content">
										<p class="category">Total amount</p>
										<h3 class="title">{{config.moneylify(stat_range.total_principal +
											stat_range.total_interest
											+ stat_range.total_fee)}}</h3>
									</template>
								</stats-card>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>paid</md-icon>
									</template>
									<template slot="content">
										<p class="category">Total principal</p>
										<h3 class="title">{{config.moneylify(stat_range.total_principal)}}</h3>
									</template>
								</stats-card>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>paid</md-icon>
									</template>
									<template slot="content">
										<p class="category">Total interest</p>
										<h3 class="title">{{config.moneylify(stat_range.total_interest)}}</h3>
									</template>
								</stats-card>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>paid</md-icon>
									</template>
									<template slot="content">
										<p class="category">Total fee</p>
										<h3 class="title">{{config.moneylify(stat_range.total_fee)}}</h3>
									</template>
								</stats-card>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>paid</md-icon>
									</template>
									<template slot="content">
										<p class="category">Total loan amount</p>
										<h3 class="title">{{config.moneylify(stat_range.total_loan_amount)}}</h3>
									</template>
								</stats-card>
							</div>
						</div>
					</md-card-content>
				</md-card>
				<!-- <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
					<md-card>
						<md-card-header data-background-color="orange">
							<h4 class="title">សមាជិកថ្មី</h4>
							<p class="category">សមាជិកទើបបញ្ចូលថ្មី ៥ ចុងក្រោយ</p>
						</md-card-header>
						<md-card-content>
							<new-member></new-member>
						</md-card-content>
					</md-card>
				</div> -->
			</div>
		</div>
		<div class="client" v-if="$store.state.authentication.account_type != 'adm'">
			<div class="md-layout" v-if="loaded">
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>request_quote</md-icon>
						</template>

						<template slot="content">
							<p class="category">ចំនួនកម្ជីរបស់ខ្ញុំ</p>
							<h3 class="title">{{client_stat.total_loan}}</h3>
						</template>
					</stats-card>
				</div>
				<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
					<stats-card data-background-color="orange">
						<template slot="header">
							<md-icon>payment</md-icon>
						</template>
						<template slot="content">
							<p class="category">ការបង់ប្រាក់របស់ខ្ញុំ</p>
							<h3 class="title">{{client_stat.total_paid_payment}} / {{client_stat.total_payment}}</h3>
						</template>
					</stats-card>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import StatsCard from '@/components/Cards/StatsCard'
	import { Datetime } from 'vue-datetime';
	export default {
		components: {
			StatsCard,
			Datetime
		},
		created() {
			if (this.$store.state.authentication.account_type == 'adm') {
				this.$http.get(this.config.api + "/admin/get/stat").then(data => {
					this.stat = data.body.data
					this.loaded = true;
				});
				this.$http.get(this.config.api + "/admin/get/stat/current_month").then(data => {
					this.stat_current_month = data.body.data
					// this.loaded = true;
				});
			} else {
				this.$http.get(this.config.api + "/admin/client/get_stat").then(data => {
					this.client_stat = data.body.data
					this.loaded = true;
				});
			}


		},
		computed: {
			capital() {
				let total = 0;
				total = this.stat.total_deposit - this.stat.total_withdraw
				total = total + this.stat.total_interest + this.stat.total_fee
				return total
			},
			active_balance() {
				let total = 0;
				total = this.stat.total_deposit - this.stat.total_withdraw + this.stat.total_paid_interest - this.stat.total_principal + this.stat.total_paid_principal + this.stat.total_fee
				return total;
			},
			passive_balance() {
				let total = 0;
				total = this.stat.total_interest + this.stat.total_principal - this.stat.total_paid_interest - this.stat.total_paid_principal
				return total;
			},
			profit() {
				let total = 0;
				total = this.stat.total_fee + this.stat.total_paid_interest
				return total;
			}
		},
		methods: {
			getData() {
				let start_date = (new Date(this.range.start_date)).getTime();
				let end_date = (new Date(this.range.end_date)).getTime();
				// console.log(start_date);
				// console.log(end_date);
				this.$http.get(this.config.api + "/admin/get/stat/by_range/" + start_date + "/" + end_date).then(data => {
					this.stat_range = data.body.data
					// this.loaded = true;
				});
			}
		},
		data() {
			return {
				loaded: false,
				range: {
					start_date: "",
					end_date: "",
				},
				client_stat: {
					total_loan: 0,
					total_payment: 0,
					total_paid_payment: 0
				},
				stat_range: {
					total_fee: 0,
					total_loan_amount: 0,
					total_interest: 0,
					total_paid_interest: 0,
					total_principal: 0,
					total_paid_principal: 0,
				},
				stat_current_month: {
					total_fee: 0,
					total_loan_amount: 0,
					total_interest: 0,
					total_paid_interest: 0,
					total_principal: 0,
					total_paid_principal: 0,
				},
				stat: {
					total_admin: 0,
					total_loan: 0,
					total_finish_loan: 0,
					total_client: 0,
					total_payment: 0,
					total_paid_payment: 0,
					total_loan_amount: 0,
					total_fee: 0,
					total_interest: 0,
					total_paid_interest: 0,
					total_principal: 0,
					total_paid_principal: 0,
					total_deposit: 0,
					total_withdraw: 0
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue